import Link from "next/link";

import React from "react";

import EntityLogo from "components/EntityLogo";
import { useGlobalState } from "hooks/useGlobalState";

type Props = {
  id: string;
  logoUrl: string;
  name: string;
  slug: string;
  children?: any;
};

const EntitySnippet = ({ id, logoUrl, name, children, slug }: Props) => {
  const [_, setShowFeedSettings] = useGlobalState(
    "showFeedSettingsModal",
    false
  );

  return (
    <div key={id} className="flex items-center mb-[10px]">
      <Link
        className="mr-[8px]"
        onClick={() => {
          setTimeout(() => {
            setShowFeedSettings(false);
          }, 0);
        }}
        href={`/entities/${slug}/research`}
      >
        <div className="flex items-center">
          <div className="border-solid mr-[5px] border-black/5 w-[38px] h-[38px] flex items-center justify-center">
            <EntityLogo
              entity={{ logoUrl: { small: logoUrl }, prettyName: name }}
              size={32}
            />
          </div>
          <h3 className="text-[15px] w-[260px] font-bold mb-0 truncate">
            {name}
          </h3>
        </div>
      </Link>

      {children}
    </div>
  );
};

export default EntitySnippet;
